import { render, staticRenderFns } from "./IconChevronDownSolid.vue?vue&type=template&id=66801dfe"
import script from "./IconChevronDownSolid.vue?vue&type=script&lang=js"
export * from "./IconChevronDownSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports